import React from "react";

export default function DashboardInquilino() {
  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ margin: 0, marginBottom: 8 }}>Dashboard Inquilino</h2>
      <p style={{ opacity: 0.9 }}>
        Sube tu documentación, revisa reservas y contratos. (Contenido demo temporal)
      </p>
    </div>
  );
}
